<template>
    <popup :opened="dataToShow" @close="changeToShow(false)">

        <!-- BEGIN Content modal add referent -->
        <div>
            <div class="my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
                <h3 class="mb-10">Modifier le dossier « {{folder.name}} »</h3>

                <form class="flex flex-col items-center mb-5" autocomplete="off">
                    <input-text
                        name="folderName"
                        libelle="Nom du dossier"
                        :value="folderToEdit.name" @input="(newValue) => {folderToEdit.name = newValue}"
                        :error="true"
                        :msg-error="((errors || [])['destination.name'] || [])[0]"
                        class="lg:w-1/2 mb-5"
                        :maxlength="40"
                    />
                    <div class="min-w-max">
                        <div class="text-sm text-gray-600 mb-2">Couleur du dossier</div>
                        <div class="flex space-x-7">
                            <div
                                v-for="(color, index) in colors" :key="index"
                                :class="'flex items-center justify-center transition ease-in-out duration-300 transform hover:scale-110 cursor-pointer border rounded-md w-8 h-8 '+color.border+' '+color.bg"
                                @click="selectColor(index)"
                            >
                                <icon v-if="color.name == folderToEdit.color" name="checkmark" :class="color.checkmark + ' h-3 w-3'" />
                            </div>
                        </div>
                    </div>
                    <div class="text-red-500 text-sm mt-2 max-w-1/2">
                        {{((errors || [])['destination.color'] || [])[0]}}
                    </div>
                </form>

                <div class="mb-10 text-red-500 text-sm text-center">
                    {{((errors || [])['forbidden'] || [])[0]}}
                </div>

                <div class="flex justify-center space-x-5">
                    <action-button
                        border-color="border-pink-600"
                        text-color="text-pink-600"
                        bg-color="bg-pink-100"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        libelle="Annuler"
                        :uppercase="true"
                        @clickAction="changeToShow(false)"
                    />
                    <action-button
                        v-if="saving"
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-gray-600"
                        bg-color-square="bg-gray-600"
                        libelle="Modifier"
                        :uppercase="true"
                        type-shadow="shadow-gray"
                    />
                    <action-button
                        v-else
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        libelle="Modifier"
                        :uppercase="true"
                        type-shadow="shadow-pink"
                        @clickAction="editFolder()"
                    />
                </div>
            </div>
        </div>
        <!-- END Content modal add referent -->
    </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import ActionButton from './../../../components/ActionButton';
import InputText from './../../../components/Inputs/InputText';
import Icon from './../../../components/Icon';

import Constants from  './../../../constants';

export default {
  name:'EditFolderPopup',

  props:{
    dataToShow: Boolean,
    errors: Object,
    saving:{
      type:Boolean,
      required:false,
      default:false,
    },
    parentFolder:{
      type:String,
      required:false,
      default: null,
    },
    folder: Object,
  },

  data() {
    return {
      folderToEdit:{
        name:'',
        parent:this.parentFolder,
        color:'',
      },

      colors:[
        {
          name: 'indigo',
          bg: 'bg-indigo-200',
          border:'border-indigo-600',
          checkmark: 'text-indigo-600',
          shadow: 'shadow-indigo',
          selected:false,
        },
        {
          name: 'pink',
          bg: 'bg-pink-100',
          border:'border-pink-600',
          checkmark: 'text-pink-600',
          shadow: 'shadow-pink',
          selected:false,
        },
        {
          name: 'teal',
          bg: 'bg-teal-100',
          border:'border-teal-600',
          checkmark: 'text-teal-600',
          shadow: 'shadow-teal',
          selected:false,
        },
        {
          name: 'orange',
          bg: 'bg-orange-100',
          border:'border-orange-600',
          checkmark: 'text-orange-600',
          shadow: 'shadow-orange',
          selected:false,
        },
        {
          name: 'gray',
          bg: 'bg-gray-200',
          border:'border-gray-600',
          checkmark: 'text-gray-600',
          shadow: 'shadow-gray',
          selected:false,
        },
      ]
    };
  },

  components:{
    Popup,
    ActionButton,
    InputText,
    Icon
  },

  computed:{
    //
  },

  methods:{

    changeToShow(val){
      this.$emit('showChange', val);
    },

    editFolder(){
      this.$emit('editFolder', this.folderToEdit);
    },

    selectColor(index){
      this.folderToEdit.color = this.colors[index].name;
    }
  },

  watch:{
    dataToShow:function(){
      this.folderToEdit = {
        name:this.folder.name,
        parent:this.parentFolder,
        color:this.folder.color,
      };
    }
  }
};
</script>
